/**
 * @module app.cm
 */

import * as CM from 'app/cm/models/essette-api';
import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { CaseService } from 'app/cm/services/case-service';
import { I18N } from 'aurelia-i18n';
import { RouteConfig } from 'aurelia-router';
import { ICaseSummaryModelData } from 'app/cm/components/summary/case-summary';

@autoinject()
export class CaseSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    private case: CM.Case | null = null;
    protected modelData: ICaseSummaryModelData | null = null;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly caseService: CaseService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);

    }

    protected async activate(params: { caseId: string }, routeConfig: RouteConfig): Promise<void> {
        if(!params?.caseId) { throw new Error('Missing required parameters: caseId'); }

        await this.reload(params.caseId);

        if(this.case && routeConfig.navModel) {
            const title = this.i18n.tr('cm:routes.case.summary.$title', { number: this.case.number });
            routeConfig.navModel.setTitle(title);
        }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    public async reload(caseId: string): Promise<void> {
        if(caseId) {
            await this.loadCase(caseId);
            if(!this.case) {
                throw new Error('Unable to load case');
            }

            this.modelData = {
                caseId: this.case.id || '',
                memberId: this.case.member?.id || '',
                readonly: true
            };
        }
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadCase(caseId: string): Promise<void> {
        const includes = [
            'member'
        ];

        const fields = [
            'member.id',
            'number'
        ];

        try {
            this.state.beginLoad();

            const response = await this.caseService.loadCase(caseId, includes, fields);
            this.case = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
